import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

interface WindowFooterProps {
  onCancel: () => void;
  cancelLabel?: string;
  //? Ação principal. Sem onConfirm o botão é type="submit" (formulário em volta faz o envio)
  confirmLabel?: string;
  onConfirm?: () => void;
  confirmVariant?: 'primary' | 'danger';
  confirmDisabled?: boolean;
  //? Esconde a ação principal (janela só de leitura: fica só o Cancelar/Fechar)
  hideConfirm?: boolean;
  //? Requisição em andamento: trava os dois botões e mostra o rótulo de carregamento (proteção de duplo clique)
  loading?: boolean;
  loadingLabel?: string;
  //? Conteúdo alinhado à esquerda (ex.: botão Anterior de formulário por etapas)
  start?: React.ReactNode;
  className?: string;
}

//* Rodapé padrão das janelas: Cancelar + ação principal, lado a lado, alinhados à direita.
const WindowFooter: React.FC<WindowFooterProps> = ({
  onCancel,
  cancelLabel = 'Cancelar',
  confirmLabel = 'Salvar',
  onConfirm,
  confirmVariant = 'primary',
  confirmDisabled = false,
  hideConfirm = false,
  loading = false,
  loadingLabel = 'Salvando...',
  start,
  className,
}) => (
  <div className={`window-footer d-flex align-items-center gap-2 pt-3 mt-3 border-top ${className ?? ''}`}>
    {start && <div className="d-flex align-items-center gap-2">{start}</div>}
    <div className="d-flex align-items-center gap-2 ms-auto">
      <Button type="button" variant="secondary" onClick={onCancel} disabled={loading}>
        {cancelLabel}
      </Button>
      {!hideConfirm && (
        <Button
          //? key muda junto com o type: evita o navegador reaproveitar o botão "Avançar" como submit na troca de etapa
          key={onConfirm ? 'action' : 'submit'}
          type={onConfirm ? 'button' : 'submit'}
          variant={confirmVariant}
          className={`d-flex align-items-center gap-2 ${confirmVariant === 'primary' ? 'btn-window-confirm' : ''}`}
          onClick={onConfirm}
          disabled={loading || confirmDisabled}
        >
          {loading && <Spinner animation="border" size="sm" role="status" aria-hidden="true" />}
          {loading ? loadingLabel : confirmLabel}
        </Button>
      )}
    </div>
  </div>
);

export default WindowFooter;
